import React from 'react';
import { Modal } from 'react-bootstrap';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import { LabelText } from '../../Language';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import {changeRequestTooltip} from '../../../components/UI/Tooltip/Tooltip';
import {RemainingCharacters} from '../../../components/UI/RemainingCharacters/RemainingCharacters';
import config from '../../../common/const/config';
import './UnblockContract.css';

const crReasonChangeHandler = (e, row, props) => {
    row.unblockChangeRequest.businessPartnerRemarks = e.target.value;
    if(e.target.value !== "") {
        row.businessPartnerRemarks_ErrorMessage = ""; 
    }
    props.setRevenueData(row.index, row.contractCode, row);

}

const submitRequestButton = (props, remarks_placeholder) =>{

    const isDisabled=(!props.row || !props.row.unblockChangeRequest || 
        !props.row.unblockChangeRequest.businessPartnerRemarks ||
        (props.row.unblockChangeRequest.businessPartnerRemarks 
        && props.row.unblockChangeRequest.businessPartnerRemarks.length === 0));
    return (
        <div>
            <div className="Unblock-Reason-Title"><LabelText tid="reason_business_partner" /></div>
            <div>
                <textarea type="text" maxLength={config.maxCharLengthOfRemarks} 
                rows="3" cols="40" style={{resize: "none"}} 
                placeholder={remarks_placeholder}
                className={"form-control cr-remarks"}
                value={props.row.unblockChangeRequest && props.row.unblockChangeRequest.businessPartnerRemarks}
                onChange={(e)=>crReasonChangeHandler(e, props.row, props)} />
                {
                    props.row.unblockChangeRequest.businessPartnerRemarks && props.row.unblockChangeRequest.businessPartnerRemarks.length > 0 ?
                    <RemainingCharacters enteredCharsLength={props.row.unblockChangeRequest.businessPartnerRemarks.length} />
                    : undefined
                }
            </div>
            <div className="Unblock-Request-Btn-Container">
                <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("send_change")}> 
                    <div className={isDisabled ? "unblock-request-icon unblock-request-icon-disabled" 
                                    : "unblock-request-icon"} role= {"button"} tabIndex={0} 
                        disabled={isDisabled}
                        onClick={(ev) => !isDisabled && props.onSubmitUnblockRequestHandler(ev, props.row)}
                        onKeyDown={(ev)=>{ if (ev.key === "Enter"  && !isDisabled) props.onSubmitUnblockRequestHandler(ev, props.row)}} 
                    />
                </CustomOverlayTrigger>
            </div>
        </div>
    )
}

const UnblockContract = (props) => {
    const languageContext = React.useContext(LanguageContext);
    return (
        <div className="Unblock-Modal-container">
            <Modal dialogClassName={"Model-dialogue"} show= {props.showModel}   
                onHide={() => { props.onHideHandler(false, false); }}
                backdrop =  "static" 
                keyboard = {true}>
                {
                    <Modal.Header  closeButton =  {true}
                            className= "Unblock-Modal-header" 
                            style = {{backgroundColor : '#25336C'}} >
                        <div className="Unblock-Modal-header-title">
                            <LabelText tid="unblock_request_header" />
                        </div>
                    </Modal.Header>
                }
                <Modal.Body>
                    <div className= "Bulk-processing-body">
                        <div className = "Unblock-BusinessPartner-label">{props.BusinessPartnerCode}</div>
                        {props.row.contractCode && <div className = "Unblock-RevenueDate-label">{<LabelText tid="contractcode" />} {props.row.contractCode}</div>}
                        {props.row.unblockChangeRequest.unblockFromDate && <div className = "Unblock-RevenueDate-label">{<LabelText tid="unblock_from" />} {props.row.unblockChangeRequest.unblockFromDate}</div>}
                        <div className="Unblock_Button-Container">
                            { submitRequestButton(props, languageContext && languageContext.labels["allowed_chars"]) }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )};

export default UnblockContract;